import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { withTranslation } from '../src/i18n';
import { TP } from '../constants/consts';
import Layout, { LayoutContent } from '../components/Layout';
import H1 from '../components/H1';
import SubTitle from '../components/SubTitle';
import route from '../constants/routes';
import NextLink from '../components/NextLink';
import { createSeoStringFromArray } from '../utils/seo';

const useStyles = makeStyles()(() => ({
  section: {
    display: 'block',
    marginTop: '1.5rem',
  },
}));

const PaymentTerms = ({ t }) => {
  const { classes, cx } = useStyles();

  return (
    <Layout
      customBreadcrumbs={[
        { path: route.HOME, title: `${TP}.m_HOME` },
        { path: `${route.PAYMENT_TERMS}/`, title: `${TP}.m_SUBSCRIPTION_AND_PAYMENT_TERMS` },
      ]}
      title={t(`${TP}.m_SUBSCRIPTION_AND_PAYMENT_TERMS`)}
      seo={{
        title: createSeoStringFromArray([t(`${TP}.m_SUBSCRIPTION_AND_PAYMENT_TERMS`), t(`${TP}.m_OPERABASE`)]),
        ogTitle: createSeoStringFromArray([t(`${TP}.m_SUBSCRIPTION_AND_PAYMENT_TERMS`), t(`${TP}.m_OPERABASE`)]),
        description: t(`${TP}.m_SUBSCRIPTION_RENEWAL`),
      }}
    >
      <LayoutContent>
        <H1>{t(`${TP}.m_SUBSCRIPTION_AND_PAYMENT_TERMS`)}</H1>
        <article>
          <sections className={classes.section}>
            <SubTitle>Renewing your subscription</SubTitle>
            <p>
              Subscriptions renew automatically until you cancel them. We remind you of upcoming payments depending on
              your payment cycle
            </p>
            <ul>
              <li>Monthly payment: We issue an invoice upon charging you every month and send this to your email.</li>
              <li>
                Annual payment: We issue an email reminder of your upcoming renewal 30 days (“Reminder Date”) before
                charging you.
              </li>
            </ul>
          </sections>
          <sections className={classes.section}>
            <SubTitle>Payment methods (credit cards, bank transfer)</SubTitle>
            <p>
              We use Stripe to securely process your payment. Stripe also handles all storing of your credit card data.
              When logged in, you can review your payment methods and added credit cards in your account settings to
              manage your cards.
            </p>
            <p>
              For annual subscriptions you can choose to pay by bank transfer. If this choice is made, we will issue an
              invoice due at the expiry date with payment details at the Reminder Date mentioned above.{' '}
            </p>
            <p>
              In case an automatic payment fails, we automatically retry 3 times over a period of 2 weeks after which we
              may cancel your subscription.
            </p>
            <p>
              In case of late payment of bank transfer we remind a total of 2 times over 2 weeks. Thereafter we may
              cancel your subscription.
            </p>
          </sections>
          <sections className={classes.section}>
            <SubTitle>Cancellation</SubTitle>
            <p>
              You may cancel your subscription anytime and it will then expire at the end of a subscription term.
              Contact us on contact@operabase.com
            </p>
            <p>
              Allow us up to 5 weekdays to process your cancellation. In some cases, we might ask you for your reason to
              cancel in order to improve our offering in the future.
            </p>
          </sections>
          <p>
            <NextLink href={route.TERMS_AND_CONDITIOS}>{t(`${TP}.FN_TERMCOND`)}</NextLink>
          </p>
          <p>
            <NextLink href={route.PRIVACY}>{t(`${TP}.FN_PRIVPOL`)}</NextLink>
          </p>
          <p>
            <NextLink href={route.COOKIE_POLICY}>{t(`${TP}.FN_CPOL`)}</NextLink>
          </p>
        </article>
      </LayoutContent>
    </Layout>
  );
};

PaymentTerms.getInitialProps = async () => ({
  namespacesRequired: ['translation'],
});

PaymentTerms.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('translation')(PaymentTerms);
